'use client'

import { GoogleTagManager } from '@next/third-parties/google'
import { type FC } from 'react'

import { useGetExperiment } from '../../experiments/hooks'
import { EXPERIMENT_CHANGE_GTM_SCRIPT } from '../../experiments/model/EXPERIMENT_NAME'
import { useWebviewContext } from '../../webview'
import { type GtmConfig } from '../config/gtmPerTenantConfig'
import { type GtmDataProps } from '../model/GtmDataProps'
import { usePushGtmDataPropsToGtmDataLayer } from '../usePushGtmDataPropsToGtmDataLayer'

type GtmProviderProps = {
  gtmConfig: GtmConfig
  gtmData?: GtmDataProps
}

export const GtmProvider: FC<GtmProviderProps> = ({ gtmConfig, gtmData }) => {
  usePushGtmDataPropsToGtmDataLayer(gtmData)

  const isWebview = useWebviewContext()
  const { gtmId, gtmScriptUrl } = gtmConfig
  const changeGtmScriptExperiment = useGetExperiment(
    EXPERIMENT_CHANGE_GTM_SCRIPT,
  )

  if (isWebview) {
    return null
  }

  if (changeGtmScriptExperiment.isEnabled) {
    return <GoogleTagManager gtmId="" gtmScriptUrl={gtmScriptUrl} />
  }

  return <GoogleTagManager gtmId={gtmId} />
}
